import * as effects from 'redux-saga/effects';
import { chatActions } from '../../actions';
import { throwError } from '../../../throwError';
import { handleError } from '../../../handleError';
import { api } from '../../../../server/api';

export function* sendData({ payload }) {
  try {
    const response = yield effects.apply(api, api.post, [
      {
        endpoint: `chats/${payload.channelId}/data/`,
        body: JSON.stringify({ data: payload.data }),
        headers: {
          'X-Report-ID': payload.report,
        },
      },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    yield effects.put(chatActions.fetchChannels());
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(chatActions.stopFetching());
  }
}
